__turbopack_context__.v({
  "ProductSliderSection": "ProductSliderSection-module__kOAlsa__ProductSliderSection",
  "active": "ProductSliderSection-module__kOAlsa__active",
  "bgContainer": "ProductSliderSection-module__kOAlsa__bgContainer",
  "bottom": "ProductSliderSection-module__kOAlsa__bottom",
  "contents": "ProductSliderSection-module__kOAlsa__contents",
  "descriptions": "ProductSliderSection-module__kOAlsa__descriptions",
  "image": "ProductSliderSection-module__kOAlsa__image",
  "item": "ProductSliderSection-module__kOAlsa__item",
  "left": "ProductSliderSection-module__kOAlsa__left",
  "productContainer": "ProductSliderSection-module__kOAlsa__productContainer",
  "right": "ProductSliderSection-module__kOAlsa__right",
  "title": "ProductSliderSection-module__kOAlsa__title",
  "top": "ProductSliderSection-module__kOAlsa__top",
});
